<template>
  <div>
      <li class="infoList">
        <span class="infoListLeft">{{obj.label}}</span>
        <span class="infoListRight"
          >{{obj.firstUnit}} {{obj.value}} {{obj.lastUnit}}</span
        >
      </li>
  </div>
</template>

<script>
export default {
  name: 'DataItem',
  props: ['obj'],
  data() {
    return {
      // showTermPicker: false,
      // text: '',
    };
  },
  watch: {
    // value: {
    //   handler(val) {
    //     console.log(val, this.columnsTerm);
    //     if (val) {
    //       // eslint-disable-next-line no-nested-ternary
    //       this.text = this.columnsTerm.length > 0
    //         ? this.columnsTerm.filter((e) => e.value === val).length > 0 ? this.columnsTerm.filter((e) => e.value === val)[0].text : ''
    //         : '';
    //     }
    //   },
    //   deep: true,
    //   immediate: true,
    // },
  },
  methods: {
    // onConfirm(obj) {
    //   this.$emit('input', obj.value);
    //   this.showTermPicker = false;
    // },
  },
};
</script>
<style scoped>
.infoList {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 90%;
  height: 50px;
  margin: 0 auto;
}
.infoListLeft {
  color: rgba(56, 56, 56, 1);
  font-size: 14px;
  flex: 0.3;
  text-align: left;
}
.infoListRight {
  color: rgba(128, 128, 128, 1);
  font-size: 14px;
  flex: 0.7;
  text-align: right;
}
</style>
